import getValidValues from 'FI/consumer/eligibility/controller/getValidValues'
import { updateMembers } from 'FI/consumer/eligibility/controller/updateMembers'
import scrollToError from 'core/DOM/scrollToError'
import store from 'utils/store/withMiddleware'
import storage from 'proxy-storage'
import { sendUserEligibilityEvent } from 'core/services/email/blueshift/implementations/eligibility'
import { preventOnCloseEvent } from 'core/services/onClose'
import { updateSessionContext } from 'core/services/updateApplicantContext'

function saveStorage(formValues) {
  const state = store.getState()
  const hcStorage = storage.getItem('hc')

  hcStorage.members = updateMembers(hcStorage.members, formValues)
  hcStorage.pivotPlan.planId = state.planId
  hcStorage.pivotPlan.questions = state.questions.map(question => ({
    id: question.id,
    question: question.question,
    questionSubtext: question.question_subtext,
    answer: state.answersPivot[`q${question.id}`]
  }))

  storage.setItem('hc', hcStorage)
}

async function handleSubmit(e, controllers, isExternalRedirect = false) {
  e.preventDefault()

  const { formValues, isValidForm } = getValidValues(controllers, true)

  const hcStorage = storage.getItem('hc')

  await updateSessionContext(hcStorage, null)
  if (isValidForm) {
    saveStorage(formValues)
    window.dataLayerPushEvent('SUBMIT_ELIGIBILITY')
    if (isExternalRedirect) {
      sendUserEligibilityEvent()
    } else {
      preventOnCloseEvent()
    }

    window.location = e.currentTarget.href
  } else {
    scrollToError('.error, .invalid-member')
  }
}

export default handleSubmit
